import React from "react";
import PageLayout from "../../PageLayout";
import SecondPage from "./SecondPage";
import FourthPage from "./FourthPage";
import VideoCareer from "./VideoCareer";

const videos = [
  
];

function Documentary() {
  return (
    <div>
      <PageLayout
        title="Let us give wings to your stories"
        description="We at IBEX FILMZ understand the evolving landscape of digital media and its impact on audiences worldwide. Leveraging cutting-edge technology and creative storytelling, we ensure that each video or film we produce not only meets but exceeds the expectations of our clients. Our team of experts specializes in bringing ideas to life, transforming visions into cinematic experiences that resonate with viewers, leaving a lasting impression. "
        videosrc="./video.mp4"
      />
      <SecondPage
        title="Documentaries"
        para="Welcome to our documentary films video production showcase, where stories come to life with depth and authenticity!
Our passion lies in capturing the essence of real-life events, compelling narratives, and impactful subjects that resonate with audiences. Whether it's a thought-provoking social issue, a cultural exploration, or a brand's journey, our documentary films are crafted to inform, inspire, and connect on a profound level.
With a meticulous approach to storytelling and cutting-edge technology, we ensure every frame reflects the heart of the narrative. From captivating visuals to authentic interviews and immersive footage, our documentaries are designed to leave a lasting impression.
"
      />
      <VideoCareer videos={videos} />

    </div>
  );
}

export default Documentary;
